export const MONTHLY_FEE = 8;
export const FORMATTED_MONTHLY_FEE = `$${MONTHLY_FEE}`;

export const FREE_PERMITTED_LIMIT = 3
export const FREE_PERMITTED_LIMIT_TIME_FRAME_DAY = 7  // days

// You can add other global constants here
//export const FREE_TRIAL_MONTHS = 3;
//export const FREE_TRIAL_MONTHS = 12;
//export const CURRENCY = 'USD';